import React, { useContext, useState, useEffect, useCallback } from "react";
import localforage from "localforage";
import { useSpring, animated } from "@react-spring/web";
import styles from "./TempleMap.module.scss";
import MainMenu from "../MainMenu/MainMenu.jsx";
import AchievementProgressBar from "../AchievementProgressBar/AchievementProgressBar.jsx";
import SelectedMapObject from "../SelectedMapObject/SelectedMapObject.jsx";
import MapPanel from "../MapPanel/MapPanel.jsx";
import pinsData from "../../pins";
import { LanguageContext } from "../../contexts/LanguageContext.jsx";
import MapCanvas from "../MapCanvas/MapCanvas.jsx";
import Achievements from "../Achievements/Achievements.jsx";
import AchievementCongratulations from "../AchievementCongratulations/AchievementCongratulations.jsx";
import Gift from "../Gift/Gift.jsx";

import { loadVisitedPins, getVisitedPins } from "../../visitedPinsStorage";

import achievements from "../../achievements";

const TempleMap = () => {
  const [pins, setPins] = useState(pinsData);
  const [selectedPin, setSelectedPin] = useState(null);
  const [showAchievements, setShowAchievements] = useState(false);
  const [showCongratulations, setShowCongratulations] = useState(false);
  const [showGift, setShowGift] = useState(false);
  const [isCongratulationsShownOnce, setIsCongratulationsShownOnce] =
    useState(false);
  const [visitedPins, setVisitedPins] = useState([]);

  const { localizedData } = useContext(LanguageContext);

  useEffect(() => {
    const initializeData = async () => {
      await loadVisitedPins();
      const visitedPinsData = await getVisitedPins();
      setVisitedPins(visitedPinsData);
      setPins([...pinsData]);
    };

    initializeData();
  }, []);

  const animationProps = useSpring({
    opacity: selectedPin ? 1 : 0,
    config: { duration: 300 },
  });

  const handlePinClick = useCallback(
    (id) => {
      const clickedPin = pins.find((pin) => pin.id === id);

      setSelectedPin(
        clickedPin?.status === "selected"
          ? null
          : { id: clickedPin.id, name: clickedPin.name }
      );

      setPins((prevPins) =>
        prevPins.map((pin) => ({
          ...pin,
          status:
            pin.id === id && clickedPin?.status !== "selected"
              ? "selected"
              : "default",
        }))
      );
    },
    [pins]
  );

  const handleShowAchievements = () => {
    setPins((prevPins) =>
      prevPins.map((pin) => ({ ...pin, status: "default" }))
    );
    setSelectedPin(null);
    setShowAchievements(true);
  };

  useEffect(() => {
    const checkAndSetCongratulations = async () => {
      const savedStatus = await localforage.getItem(
        "isCongratulationsShownOnce"
      );
      const shouldShowCongratulations =
        visitedPins.length === achievements.length && !savedStatus;

      if (shouldShowCongratulations) {
        setShowCongratulations(true);
        setIsCongratulationsShownOnce(true);
        await localforage.setItem("isCongratulationsShownOnce", true);
      }
    };

    checkAndSetCongratulations();
  }, [visitedPins.length]);

  return (
    <>
      <div className={styles.templeMap}>
        <MainMenu onShowAchievements={handleShowAchievements} />
        <AchievementProgressBar
          count={visitedPins.length}
          countAll={achievements.length}
        />

        <MapCanvas pins={pins} onPinClicked={handlePinClick} />

        {selectedPin && (
          <animated.div style={animationProps}>
            <SelectedMapObject
              id={selectedPin.id}
              name={selectedPin.name}
              title={
                localizedData?.[selectedPin.name]?.menu_name ||
                localizedData?.[selectedPin.name]?.title ||
                selectedPin.name
              }
              title2={localizedData?.[selectedPin.name]?.menu_name2 || null}
            />
          </animated.div>
        )}

        {showAchievements && (
          <Achievements onClose={() => setShowAchievements(false)} />
        )}

        {showCongratulations && (
          <AchievementCongratulations
            onGiftReceive={() => {
              setShowCongratulations(false);
              setShowGift(true);
            }}
            onClose={() => setShowCongratulations(false)}
          />
        )}

        {showGift && <Gift onClose={() => setShowGift(false)} />}
      </div>
    </>
  );
};

export default TempleMap;
